export const GOMBA_PRODUCT_SYNCHRONIZATION_STATUS = {
  NOT_SYNCRONIZED: { label: 'Not Synchronized', value: 0 },
  SYNCHRONIZED: { label: 'Synchronized', value: 1 },
  REMOVED: { label: 'Removed', value: 2 },
}